var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTarteelLogo = function SvgTarteelLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.74 0h12.52A5.74 5.74 0 0 1 24 5.74v12.52A5.74 5.74 0 0 1 18.26 24H5.74A5.74 5.74 0 0 1 0 18.26V5.74A5.74 5.74 0 0 1 5.74 0Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.74 0h12.52A5.74 5.74 0 0 1 24 5.74v12.52A5.74 5.74 0 0 1 18.26 24H5.74A5.74 5.74 0 0 1 0 18.26V5.74A5.74 5.74 0 0 1 5.74 0Z",
    fill: "url(#a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.74 0h12.52A5.74 5.74 0 0 1 24 5.74v12.52A5.74 5.74 0 0 1 18.26 24H5.74A5.74 5.74 0 0 1 0 18.26V5.74A5.74 5.74 0 0 1 5.74 0Z",
    fill: "url(#b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.74 0h12.52A5.74 5.74 0 0 1 24 5.74v12.52A5.74 5.74 0 0 1 18.26 24H5.74A5.74 5.74 0 0 1 0 18.26V5.74A5.74 5.74 0 0 1 5.74 0Z",
    fill: "url(#c)",
    fillOpacity: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.74 0h12.52A5.74 5.74 0 0 1 24 5.74v12.52A5.74 5.74 0 0 1 18.26 24H5.74A5.74 5.74 0 0 1 0 18.26V5.74A5.74 5.74 0 0 1 5.74 0Z",
    fill: "url(#d)",
    fillOpacity: 0.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.74 0h12.52A5.74 5.74 0 0 1 24 5.74v12.52A5.74 5.74 0 0 1 18.26 24H5.74A5.74 5.74 0 0 1 0 18.26V5.74A5.74 5.74 0 0 1 5.74 0Z",
    fill: "url(#e)",
    fillOpacity: 0.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.04 9.958c-.551.551-.827.827-1.167.827-.34 0-.616-.276-1.168-.827l-2.684-2.684c-.551-.551-.827-.827-1.167-.827-.34 0-.616.276-1.168.827l-3.584 3.584c-.55.551-.827.827-.827 1.168 0 .34.276.616.827 1.167l3.584 3.584c.552.551.827.827 1.168.827.34 0 .616-.276 1.167-.827l2.684-2.684c.552-.551.827-.827 1.168-.827.34 0 .616.276 1.167.827l.811.811c.551.551.827.827 1.168.827.34 0 .616-.276 1.167-.827l1.711-1.71c.551-.552.827-.828.827-1.168 0-.34-.276-.617-.827-1.168l-1.71-1.71c-.552-.552-.828-.828-1.168-.828-.34 0-.617.276-1.168.827l-.81.811Z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.04 9.958c-.551.551-.827.827-1.167.827-.34 0-.616-.276-1.168-.827l-2.684-2.684c-.551-.551-.827-.827-1.167-.827-.34 0-.616.276-1.168.827l-3.584 3.584c-.55.551-.827.827-.827 1.168 0 .34.276.616.827 1.167l3.584 3.584c.552.551.827.827 1.168.827.34 0 .616-.276 1.167-.827l2.684-2.684c.552-.551.827-.827 1.168-.827.34 0 .616.276 1.167.827l.811.811c.551.551.827.827 1.168.827.34 0 .616-.276 1.167-.827l1.711-1.71c.551-.552.827-.828.827-1.168 0-.34-.276-.617-.827-1.168l-1.71-1.71c-.552-.552-.828-.828-1.168-.828-.34 0-.617.276-1.168.827l-.81.811Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-16.51567 16.5821 -27.6409 -27.53016 19.881 7.42)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8FF087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83EE41",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(16.24199 10.43478 -15.24946 23.73615 6.483 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#75F3AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41EEBA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-13.54253 17.37612 -28.3908 -22.12712 20.668 6.625)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6AFF52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 24,
    y1: 24,
    x2: 0,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDD0FC",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D47EF",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 18.891,
    y1: -5.41,
    x2: 9.57,
    y2: 18.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35F787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    stopColor: "#3CFF8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.599,
    stopColor: "#62D6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.948,
    stopColor: "#00A3FF"
  })))));
};
export default SvgTarteelLogo;